import React, { PropTypes } from 'react';

const AddButton = ({ onClick }) => {
    return (<div className="add-button" onClick={ onClick }>
        <div className="button">
            <div className="fa fa-plus"></div>
            <div className="deck-icon"></div>
        </div>
    </div>);
};

AddButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default AddButton;


// WEBPACK FOOTER //
// ./src/components/decklist/addbutton.js